import React, { useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom';


const Header = () => {

  useEffect(() => {
    console.log('Current path:', window.location.pathname);
    const logo = document.querySelector('.logo-area img');
    console.log('Logo element exists:', logo);
    console.log('Logo display style:', window.getComputedStyle(logo).display);
  }, []);

  return (
    <header>
      <div id="header2" className="header2-area">
        <div className="header-top-area">
          <div className="container">
            <div className="row">
              <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12">
                <div className="header-top-left">
                  <ul>
                    <li><i className="fa fa-phone" aria-hidden="true" /><NavLink to='/contact'>  +91 76 200 200 54</NavLink></li>
                    <li><i className="fa fa-envelope" aria-hidden="true" /><NavLink to='/contact'>info@ittcouncil.com</NavLink></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12">
                <div className="header-top-right">
                  <ul>
                    <li>
                      <NavLink to='/applyfrenchise' className="login-btn-area" target="_blank"><i className="fa fa-user-plus" aria-hidden="true" /> Apply Franchise</NavLink>
                    </li>
                    <li>
                      <NavLink to="https://franchise.ittcouncil.com/Login" className="login-btn-area" target="_blank" ><i className="fa fa-lock" aria-hidden="true" /> Franchise Login</NavLink>
                    </li>
                    <li>
                      <NavLink to="https://student.ittcouncil.com/Login" className="login-btn-area" target="_blank" ><i className="fa fa-lock" aria-hidden="true" /> Student Login</NavLink>
                    </li>
                    <li>
                      <NavLink to='/Verification' className="login-btn-area"><i className="fa fa-check" aria-hidden="true" /> Student Verification</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-menu-area bg-textPrimary" id="sticker">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-2 col-sm-2">
                <div className="logo-area">
                  <NavLink to='/'>
                    <img className="img-responsive" src="https://ittcouncil.com/images/ittcouncil-logo.png" alt="logo" />
                  </NavLink>
                </div>
              </div>
              <div className="col-lg-9 col-md-10 col-sm-10">
                <nav id="desktop-nav">
                  <ul>
                    <li className="active">
                      <NavLink to='/'> Home</NavLink>
                    </li>
                    <li >
                      <NavLink to='/about'>About</NavLink>
                    </li>
                    <li>
                      <NavLink to='/allcourses'>Courses</NavLink>
                      <ul>
                        <li>
                          <NavLink to='/allcourses'>All Courses</NavLink>
                        </li>
                        <li>
                          <NavLink to='/remotesensing'>Remote Sensing And GIS</NavLink>
                        </li>
                        <li>
                          <NavLink to='/animation'>Animation</NavLink>
                        </li>
                        <li>
                          <NavLink to='/industrialtraining'>Industrial Training</NavLink>
                        </li>
                        <li>
                          <NavLink to='/augumentedreality'>Augmented Reality</NavLink>
                        </li>
                        <li>
                          <NavLink to='/fashion'>Fashion/Parlour</NavLink>
                        </li>
                        <li>
                          <NavLink to='/abacus'>Abacus Courses</NavLink>
                        </li>
                        <li>
                          <NavLink to='/university'>University Courses</NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink to='/training'>Training Center</NavLink>
                    </li>
                    <li>
                      <NavLink>Apply Now</NavLink>
                      <ul>
                        <li>
                          <NavLink to='/atcregistration'>ATC Registration</NavLink>
                        </li>
                        <li>
                          <NavLink to='/registration'>Student Registration</NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink to='/contact'>Contact</NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Menu Area Start */}
      <div className="mobile-menu-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mobile-menu">
                <nav id="dropdown">
                  <ul>
                    <li className="active">
                      <NavLink to='/'>Home</NavLink>
                    </li>
                    <li>
                      <NavLink to='/about'>About</NavLink>
                    </li>
                    <li>
                      <NavLink to='/allcourses'>Courses</NavLink>
                      <ul>
                        <li>
                          <NavLink to='/allcourses'>All Courses</NavLink>
                        </li>
                        <li>
                          <NavLink to='/remotesensing'>Remote Sensing And GIS</NavLink>
                        </li>
                        <li>
                          <NavLink to='/animation'>Animation</NavLink>
                        </li>
                        <li>
                          <NavLink to='/industrialtraining'>Industrial Training</NavLink>
                        </li>
                        <li>
                          <NavLink to='/augumentedreality'>Augmented Reality</NavLink>
                        </li>
                        <li>
                          <NavLink to='/fashion'>Fashion/Parlour</NavLink>
                        </li>
                        <li>
                          <NavLink to='/abacus'>Abacus Courses</NavLink>
                        </li>
                        <li>
                          <NavLink to='/university'>University Courses</NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink to='/training'>Training Center</NavLink>
                    </li>
                    <li>
                      <NavLink>Apply Now</NavLink>
                      <ul>
                        <li>
                          <NavLink to='/atcregistration'>ATC Registration</NavLink>
                        </li>
                        <li>
                          <NavLink to='/registration'>Student Registration</NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink to='/contact'>Contact</NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Menu Area End */}
    </header>



  )
}

export { Header };